import { Box, Form } from '@jfs/ui-new'
import { getRandomNumber } from '@jfs/utils'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'
import { TableComponent } from '../../../comps/TableComponent'
import { RootStore, useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { createPaymentLinkPostData } from '../../../network/parsers/APIDataParser'
import { RenderPaymentFormHeader } from '../CreatePaymentLink/CreatePaymentFormHeader'
import { renderActionButtons } from './ActionButton'
import { createPaymentLinkForm } from './CreatePaymentForm'
import { styles } from './FormStyles'
import { BackgroundSeparator, leftHeaderTextbox } from './LeftHeaderTextBox'
import { renderItem } from './ReviewFormHelper'
import { getInitialValues, noExpiryString } from './StateConstant'
import { checkboxWithLeftHeader } from './TextedCheckbox'

const minuteExpiryLimit = 5

const CreatePaymentLink = ({ route }: any) => {
  const navigation = useNavigation()
  const data = route?.params?.data ?? ''
  const [reviewPaymentLinkSelected, updateReviewPaymentLink] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [reviewData, updateReviewData] = useState([])

  const { mid, createPaymentLink, updateNewLink, paymentLinkData } = useStores((store) => ({
    mid: store.user.selectedMid,
    createPaymentLink: store.links.createPaymentLink,
    updateNewLink: store.links.updateNewLinkCreatedInStore,
    paymentLinkData: store.links.paymentLinkData,
  }))

  const payLinkData = paymentLinkData()
  let storeData: any
  if (data) {
    storeData = payLinkData
  } else {
    storeData = {}
  }

  const [initValue, updateInitialVal] = useState(storeData)
  const [fetchCreatePaymentLink, createPaymentLinkHandler] = useLazyApiData(createPaymentLink)

  const createPaymentLinkState = createPaymentLinkHandler?.state
  useEffect(() => {
    if (createPaymentLinkState === 'fulfilled') {
      setIsLoading(false)
      navigation.replace(Routes.PAYMENT_LINKS)
      updateNewLink(true)
    } else if (createPaymentLinkState === 'rejected') {
      setIsLoading(false)
    }
  }, [createPaymentLinkState, navigation, updateNewLink])

  const reviewPaymentLinkInformation = () => {
    return (
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={reviewData}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderItem}
      />
    )
  }

  const toggleReviewPaymentLinkState = () => {
    updateReviewPaymentLink(!reviewPaymentLinkSelected)
  }

  const callGenerateLinkAPI = async (passData: any) => {
    const getPassParams = await createPaymentLinkPostData(passData)
    const merchantLinkId = `M${getRandomNumber(0, 99999999999999)}`
    const desc = getPassParams?.[2] ?? ''
    const customerSms = getPassParams?.[3] ?? ''
    const invoiceNumber = getPassParams?.[6] ?? ''
    const email = getPassParams?.[4] ?? ''
    const amount = getPassParams?.[0]
    const description = desc !== '' ? desc : undefined
    const pushSmsTo = customerSms !== '' ? customerSms : undefined
    const invoice = invoiceNumber !== '' ? invoiceNumber : undefined
    const linkExpiryAt = getPassParams?.[5] === noExpiryString ? undefined : getPassParams[7]
    const pushEmailTo = email !== '' ? email : undefined
    let difInTime = 0 //Expiry in minutes
    if (linkExpiryAt !== undefined) {
      const todayDateFromUTC = String(new Date()?.getDate())
      const dateFromCalendar = String(linkExpiryAt)?.substr(6, 2)

      if (dateFromCalendar === todayDateFromUTC) {
        //If ihe date selected from calendar is same date as per UTC
        const selectedTimeInHHMM = String(linkExpiryAt)?.substr(8, 4)
        const hours = new Date()?.getHours()
        const mins = new Date().getMinutes()
        const presentTime = String(hours) + String(mins)
        difInTime = Number(selectedTimeInHHMM) - Number(presentTime)
      } else {
        //Adding a dummy integer value if the selected date is more than UTC date
        difInTime = 10
      }
    }
    if (difInTime > minuteExpiryLimit && linkExpiryAt !== undefined) {
      setIsLoading(true)
      fetchCreatePaymentLink(mid, merchantLinkId, amount, description, pushSmsTo, invoice, linkExpiryAt, pushEmailTo)
    } else if (linkExpiryAt === undefined) {
      setIsLoading(true)
      fetchCreatePaymentLink(mid, merchantLinkId, amount, description, pushSmsTo, invoice, linkExpiryAt, pushEmailTo)
    } else {
      RootStore?.response?.setMessage('Expiry date shall be more than 5 minutes compared to current time.!')
    }
  }

  return (
    <ScrollView nativeID={'showListScrollBar'}>
      <Box {...styles.container}>
        <RenderPaymentFormHeader navigation={navigation} reviewPaymentLinkSelected={reviewPaymentLinkSelected} />
        <Form
          formData={createPaymentLinkForm(
            leftHeaderTextbox,
            checkboxWithLeftHeader,
            BackgroundSeparator,
            reviewPaymentLinkSelected,
            reviewPaymentLinkInformation,
          )}
          actionButtons={(props) =>
            renderActionButtons(
              navigation,
              props,
              reviewPaymentLinkSelected,
              toggleReviewPaymentLinkState,
              updateReviewData,
              callGenerateLinkAPI,
              updateInitialVal,
              isLoading,
            )
          }
          container={DefaultFormContainer}
          initialValues={getInitialValues(initValue)}
        />
      </Box>
    </ScrollView>
  )
}

export default CreatePaymentLink
